import React from 'react';

const BlockCaseContext = React.createContext(true);

export default BlockCaseContext;
